import { HawkersReportTranslations } from "./hawkers-report-pt-br";

export const HAWKERS_REPORT_ES_MX: HawkersReportTranslations = {
	title: "Panel Ambulante",
	description: "Ver el desempeño general de los vendedores ambulantes en sitio",
	general: {
		title: "Panel General",
		hawkerSelect: "Seleccione un ambulante",
		totalizers: {
			launchedProductsTotal: "Total de productos lanzados",
			returnedProductsTotal: "Total de productos devueltos",
			commissionTotal: "Comisiones totales",
			salesTotal: "Ventas totales",
		},
		table: {
			sales: "Ventas",
			devolutions: "Devoluciones",
			paymentMethod: "Métodos de pago",
			productsRelease: "Lanzamiento del producto",
			productsCancellation: "Cancelación de producto",
			noReturnNoSalesProducts: "Productos sin devolución ni venta",
			columns: {
				product: "Producto",
				quantity: "Cantidad",
				unitValue: "Valor unitario",
				total: "Total",
				commission: "Comisión",
				paymentMethod: "Método de pago",
				value: "Valor",
			},
		},
	},
	summary: {
		title: "Resumen por sesión y ciclo",
		summary: "Resumen",
		filterBreak: "Mostrar solo sesiones con ruptura de caja",
		filterClosure: "Mostrar solo sesiones pendientes de cierre",
		filterDifferentCashiers: "Mostrar solo sesiones con cajas diferentes",
		columns: {
			session: "Sesión",
			hawkerName: "Ambulante",
			hawkerDocument: "Documento",
			cycleCount: "Ciclos",
			change: "Cambia",
			receivedValue: "Valor recibido",
			break: "Ruptura de caja",
			openedAt: "Apertura",
			closedAt: "Cierre",
			openClosure: "Cierre abierto",
			cycle: "Ciclo",
			previousBalance: "Saldo anterior",
			closingValue: "Valor de cierre",
			balance: "Saldo final",
			cashierNameOpener: "Apertura de cajero",
			cashierNameCloser: "Cierre de caja",
			pub: {
				initial: "Bar de abertura",
				final: "Bar de fechamento",
			},
		},
	},
	ranking: {
		title: "Ranking",
		filename: "ranking",
		columns: {
			name: "Nombre",
			document: "Documento",
			commission: "Comisión",
			total: "Total vendido",
		},
	},
	releases: {
		title: "Lanzamientos de ambulantes",
		quantityProducts: "Cantidad de productos",
		totalValueReleases: "Valor total",
		filename: "registro-de-ambulante-{{hawker}}",
		hawkerRecord: "Registro de ambulante",
		name: "Nombre del ambulante",
		columns: {
			hawkerName: "Nombre",
			hawkerDocument: "Documento",
			total: "Total",
			productName: "Producto",
			quantity: "Cantidad",
			value: "Valor unitario",
			cycle: "Ciclo",
			date: "Fecha/Hora",
		},
	},
	cashierClosing: {
		title: "Cierre de palco de ambulante",
		name: "Nombre",
		document: "Documento",
		begin: "Apertura",
		end: "Cerrando",
		closingValue: "Valor de cierre",
		financialResume: "Resumen financiero",
		resume: "Resumen",
		value: "Valor",
		products: "Productos",
		product: "Producto",
		quantity: "Cantidad",
		unitValue: "Valor unitario",
		total: "Total",
		paymentMethods: "Métodos de pago",
		paymentMethod: "Método de pago",
		date: "Fecha y hora",
		changeEntries: "Cambiar entradas",
		bleedings: "Sangrados",
		cycleClosings: "Cierres de ciclo",
		sessionClosings: "Cierres de sesión",
		financialSummaryTitles: {
			changeFundsValue: "Cambio total",
			bleedingsValue: "Sangrado total",
			cyclesReceivedValue: "Totalizador de ciclos",
			sessionsReceivedValue: "Totalizador de sesiones",
			cashValue: "Valor en efectivo",
			valueWithCashier: "Cantidad retenida por el cajero",
			cashierDiffValue: "Cajero cerrado por rotura/excedente",
			commissionsValue: "Comisión",
		},
		diffValue: "Descanso en efectivo/Excedente",
	},
	filter: {
		filter: "Filtro",
		clickToFilter: "Haga clic para filtrar",
		employee: {
			label: "Empleado",
			description: "Ingrese el nombre del empleado",
			title: "Filtrar por empleado",
		},
		hawkerName: {
			label: "Nombre del vendedor ambulante",
			description: "Ingrese el nombre del vendedor ambulante",
			title: "Filtrar por nombre de vendedor ambulante",
		},
		hawkerDocument: {
			label: "Documento del vendedor ambulante",
			description: "Ingrese el documento del vendedor ambulante",
			title: "Filtrar por documento de vendedor ambulante",
		},
		cashierName: {
			label: "Nombre del cajero",
			description: "Ingrese el nombre del cajero",
			title: "Filtrar por nombre del cajero",
		},
		cashierDocument: {
			label: "Documento de caja",
			description: "Ingresar documento de caja",
			title: "Filtrar por documento de caja",
		},
		eventTypes: {
			label: "Tipo de movimiento",
			description: "Seleccione un tipo de movimiento",
			title: "Filtrar por tipo de movimiento",
		},
		productName: {
			label: "Nombre del producto",
			description: "Ingrese el nombre del producto",
			title: "Filtrar por nombre del producto",
		},
		barName: {
			label: "Nombre del bar",
			description: "Ingrese el nombre del bar",
			title: "Filtrar por nombre del bar",
		},
		cycleId: {
			label: "Ciclo",
			description: "Ingrese el ID del ciclo",
			title: "Filtrar por ciclo",
			error: "Ingrese un ID válido",
		},
		sessionId: {
			label: "Sesión",
			description: "Ingrese el ID de la sesión",
			title: "Filtrar por sesión",
			error: "Ingrese un ID válido",
		},
		employeeLogin: {
			label: "Login del empleado",
			description: "Ingrese el login del empleado",
			title: "Filtrar por login del empleado",
		},
	},
	transactions: {
		title: "Transacciones de Ambulante",
		description: "Lista de transacciones del ambulante en ámbito de lugar",
		columns: {
			id: "ID de la movimiento",
			hawkerName: "Nombre del Ambulante",
			hawkerDocument: "Documento del Ambulante",
			productId: "ID del Producto",
			productName: "Producto",
			barId: "ID del bar",
			barName: "Nombre del bar",
			cashierId: "ID del cajero",
			cashierName: "Nombre del Cajero",
			cashierDocument: "Documento del Cajero",
			employeeName: "Nombre del empleado",
			cycleId: "Ciclo",
			openedAt: "Fecha y hora de apertura",
			closedAt: "Fecha y hora de cierre",
			eventType: "Tipo de movimiento",
			createdAt: "Fecha/hora de movimiento",
			eventId: "Event ID",
			eventName: "Nombre del Evento",
			quantity: "Cantidad",
			amount: "Valor",
			paymentMethod: "Método de pago",
			paymentValue: "Valor pago",
			unitValue: "Valor unitario",
			totalValue: "Valor total",
			sessionId: "Sesión",
			discount: "Descuento",
			commission: "Comisión",
			balance: "Saldo del cierre de ciclo/sesión",
			employeeLogin: "Login del empleado",
			serial: "Serial del terminal",
			deviceId: "ID del dispositivo del terminal",
			productTotal: "Total del producto",
			hawkerEmployee: "Login del empleado del ambulante",
			cashierEmployee: "Login del empleado del cajero",
		},
		filter: {
			actionsType: "Seleccione un tipo de movimiento",
			employee: "Nombre del empleado",
			hawker: "Nombre o documento del vendedor ambulante",
			cashier: "Nombre o documento de caja",
		},
		sessionOpening: "Apertura de sesión",
		sessionClosure: "Cierre de sesión",
		cycleOpening: "Apertura de ciclo",
		cycleClosure: "Cierre de ciclo",
		productRelease: "Salida de ambulante",
		sale: "Ventas de ambulante",
		bleeding: "Sangrado",
		changeFund: "Cambio de fondos",
		devolution: "Devoluciones de productos de ambulante",
		cashierOpening: "Apertura de caja",
		cashierClosure: "Cierre de caja",
		cancellation: "Cancelación",
		maxSearchPeriod: "El período máximo de búsqueda es de 31 días",
	},
};
